import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import api from "../axiosConfig";
import ModalComp from "../themes/Model";
import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  createTheme,
  FormControl,
  FormHelperText,
  Grid,
  Snackbar,
  TextField,
  ThemeProvider,
} from "@mui/material";
import { getUser } from "../helpers";
import { useModalContext } from "../ModalContext";
import { LoadingButton } from "@mui/lab";
import LoadingSpinner from "../components/LoadingSpinner";

function AddNewPricelist({
  open,
  handleClose,
  data,
  setCustomOpenModal,
  shouldDisableDate,
  priceListUpdateButton,
  selectedRowData,
  isEditing,
  setIsEditing,
  updateRowData,
  getDcMrpTax,
}) {
  const user = getUser();
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState([]);
  const [productNames, setProductNames] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [selectedProductCode, setSelectedProductCode] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [priceLists, setPriceLists] = useState([]);
  const [selectedPriceList, setSelectedPriceList] = useState("");
  const [selectedPriceListValue, setSelectedPriceListValue] = useState("");
  const [loadingMrpTax, setLoadingMrpTax] = useState(false);
  const [cleared, setCleared] = React.useState(false);
  //update mrp&tax by hit apiEndpoint
  const [mrp, setMrp] = useState("");
  const [tax, setTax] = useState("");
  // global state
  const { currency, isLoading, setLoading } = useModalContext();
  const [modalFormData, setModalFormData] = useState({
    warehouse: "",
    product: "",
    ProductCode: "",
    priceList: "",
    schemeStartDate: null,
    schemeEndDate: null,
    MRP: "",
    RetailMargin: "",
    PTR: "",
    NetPtr: "",
    Tax: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (getDcMrpTax?.length > 0) {
      const data = getDcMrpTax[0];

      setSelectedWarehouse(data.Warehouse || "");
      setSelectedProduct(data.Product_Name || "");
      setSelectedProductCode(data.ProductCode || "");

      setModalFormData((prevData) => ({
        ...prevData,
        warehouse: data.Warehouse || "",
        product: data.Product_Name || "",
        productCode: data.ProductCode || "",
        // priceList: "",
        schemeStartDate: data.From_Date || null,
        schemeEndDate: data.To_Date || null,
        MRP: data.MRP || "",
        RetailMargin: data.Retailer_Margin * 100 || "",
        PTR: data.PTR || "",
        NetPtr: data.Net_PTR || "",
        Tax: data.Tax * 100 || "",
      }));
    }
  }, [getDcMrpTax]); // Runs whenever getDcMrpTax updates

  //clear date function
  React.useEffect(() => {
    if (cleared) {
      const timeout = setTimeout(() => {
        setCleared(false);
      }, 1500);

      return () => clearTimeout(timeout);
    }
    return () => {};
  }, [cleared]);

  useEffect(() => {
    if (selectedRowData?.Warehouse) {
      setSelectedWarehouse(selectedRowData.Warehouse);
    }
  }, [selectedRowData]);

  useEffect(() => {
    if (selectedRowData) {
      setModalFormData((prevData) => ({
        ...prevData,
        product: selectedRowData.Product_Name || "",
        schemeStartDate: selectedRowData.From_Date || "",
        schemeEndDate: selectedRowData.To_Date || "",
        MRP: selectedRowData.MRP || "",
        PTR: selectedRowData.PTR || "",
        NetPtr: selectedRowData.Net_PTR || "",
        RetailMargin: selectedRowData.Retailer_Margin
          ? selectedRowData.Retailer_Margin
          : "",
        Tax: selectedRowData.Tax ? selectedRowData.Tax : "",
        Pricelist: selectedRowData.Pricelist || "",
        warehouse: selectedRowData.Warehouse || "",
      }));

      setSelectedProduct(selectedRowData.Product_Name || "");
    }
  }, [selectedRowData]);

  // Separate useEffect to update PriceList
  useEffect(() => {
    if (selectedRowData?.Pricelist) {
      setSelectedPriceList(selectedRowData.Pricelist);
    }
  }, [selectedRowData]);

  useEffect(() => {
    if (selectedRowData?.Pricelist) {
      setSelectedPriceList(selectedRowData.Pricelist);
    }
  }, [selectedRowData]);

  const handlePriceListChange02 = (_, newValue) => {
    setSelectedPriceList(newValue?.Pricelist || "");
    setSelectedPriceListValue(newValue?.Pricelist || "");
  };

  const handleWarehouseChange03 = (_, newValue) => {
    setSelectedWarehouse(newValue);
  };

  // dropdown api's
  useEffect(() => {
    api
      .get("/warehouses")
      .then((response) => setWarehouses(response.data || []))
      .catch((error) => console.error("Error fetching warehouses:", error));

    api
      .get("/productswithname")
      .then((response) => setProductNames(response.data || []))
      .catch((error) => console.error("Error fetching productNames:", error));

    api
      .get("/pricelist")
      .then((response) => setPriceLists(response.data || []))
      .catch((error) => console.error("Error fetching categories:", error));
  }, []);

  // Dropdown handler's
  const handleProductChange = (event, newValue) => {
    // const selectedProduct = productNames.find(
    //   (product) => product.Product_Name === newValue
    // );

    // setSelectedProduct(selectedProduct ? selectedProduct.Product_Name : "");
    // // setSelectedProductCode(selectedProductCode ? selectedProductCode.ProductCode : "")
    // setSelectedProductCode(selectedProduct?.ProductCode || "");
    // setModalFormData((prevData) => ({
    //   ...prevData,
    //   product: selectedProduct ? selectedProduct.Product_Name : "",
    //   ProductCode: selectedProduct ? selectedProduct.ProductCode : null,
    // }));

    // if (newValue) {
    //   setErrors((prevErrors) => ({
    //     ...prevErrors,
    //     product: "",
    //   }));
    // }
    if (!newValue) return;

    setModalFormData((prevData) => ({
      ...prevData,
      product: newValue.Product_Name??"",
      ProductCode: newValue.ProductCode??"",
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      product: "",
    }));
     setSelectedProduct(newValue.Product_Name);
     setSelectedProductCode(newValue?.ProductCode || ""); 
  };

  const handleWarehouseChange02 = (event, newWarehouseValue) => {
    const selectedWarehouse = warehouses.find(
      (warehouse) => warehouse.Warehouse === newWarehouseValue
    );

    setSelectedWarehouse(selectedWarehouse ? selectedWarehouse.Warehouse : "");
    setModalFormData((prevData) => ({
      ...prevData,
      warehouse: selectedWarehouse ? selectedWarehouse.Warehouse : "",
    }));

    if (newWarehouseValue) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        warehouse: "",
      }));
    }
  };
  const handlePriceListChange = (event, newValue) => {
    setSelectedPriceList(newValue);
    setSelectedPriceListValue(newValue ? newValue.Pricelist : "");

    setModalFormData((prevData) => ({
      ...prevData,
      priceList: newValue ? newValue.PriceList : "",
    }));

    if (newValue) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        priceList: "",
      }));
    }
  };

  const handlePriceListChangeInternal = (event, newValue) => {
    setSelectedPriceList(newValue?.Pricelist || "");
    handlePriceListChange(newValue);
  };

  //date picker disable function
  const disableDateCondition = (date) => {
    const today = dayjs().startOf("day");
    const tomorrow = today.add(1, "day");
    const startDate = modalFormData.schemeStartDate
      ? dayjs(modalFormData.schemeStartDate)
      : dayjs().startOf("day");
    return (
      date.isSame(today, "day") ||
      date.isSame(tomorrow, "day") ||
      date.isBefore(startDate, "day")
    );
  };

  //[alert handler]
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  //set validation
  const validateForm = () => {
    const isDcPriceList = priceListUpdateButton === "Update DC Price";
    const newErrors = {};
    if (modalFormData.warehouse?.length === 0)
      newErrors.warehouse = "Warehouse is required";
    if (modalFormData.product?.length === 0)
      newErrors.product = "Product is required";
    if (
      !isDcPriceList &&
      !selectedPriceList &&
      modalFormData.priceList?.length === 0
    ) {
      newErrors.priceList = "PriceList is required";
    }
    if (!modalFormData.schemeStartDate)
      newErrors.schemeStartDate = "Start date is required";
    if (!modalFormData.schemeEndDate)
      newErrors.schemeEndDate = "End date is required";
    if (modalFormData.schemeStartDate && modalFormData.schemeEndDate) {
      const start = dayjs(modalFormData.schemeStartDate);
      const end = dayjs(modalFormData.schemeEndDate);
      if (end.isBefore(start))
        newErrors.schemeEndDate = "End date cannot be before start date";
    }
    if (!modalFormData.MRP) {
      newErrors.MRP = "MRP is required";
    } else if (isNaN(modalFormData.MRP)) {
      newErrors.MRP = "MRP must be a number";
    } else if (Number(modalFormData.MRP) <= 0) {
      newErrors.MRP = "MRP must be greater than 0";
    }

    if (!modalFormData.RetailMargin) {
      newErrors.RetailMargin = "RetailMargin is required";
    } else if (isNaN(modalFormData.RetailMargin)) {
      newErrors.RetailMargin = "RetailMargin must be a number";
    } else if (Number(modalFormData.RetailMargin) <= 0) {
      newErrors.RetailMargin = "RetailMargin must be greater than 0";
    }

    if (!modalFormData.PTR) newErrors.PTR = "PTR is required";
    else if (isNaN(modalFormData.PTR)) newErrors.PTR = "PTR must be a number";

    if (!modalFormData.Tax) newErrors.Tax = "Tax is required";
    else if (isNaN(modalFormData.Tax)) newErrors.Tax = "Tax must be a number";

    if (!modalFormData.NetPtr) newErrors.NetPtr = "Net Ptr is required";
    else if (isNaN(modalFormData.NetPtr))
      newErrors.NetPtr = "Net Ptr must be a number";

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  //reset Modal data
  const ResetForms = () => {
    setModalFormData({
      warehouse: "",
      product: "",
      priceList: "",
      schemeStartDate: "",
      schemeEndDate: "",
      MRP: "",
      RetailMargin: "",
      PTR: "",
      NetPtr: "",
    });

    // Reset other related states
    setSelectedWarehouse("");
    setSelectedProduct("");

    // Clear errors
    setErrors({});
  };

  const fomatBodyData = (data, isDcPriceList) => {
    console.log(selectedPriceListValue, "selectedPriceListValue");
    return {
      Warehouse: data.warehouse,
      Channel: "",
      Pricelist: !isDcPriceList ? selectedPriceListValue : "",
      ProductCode: selectedProductCode || data.productCode,
      From_Date: data.schemeStartDate,
      To_Date: data.schemeEndDate,
      MRP: data.MRP,
      Retailer_Margin: data.RetailMargin,
      PTR: data.PTR,
      Tax: data.Tax,
      Net_PTR: data.NetPtr,
      user: user,
      currencyType: currency,
      page: isDcPriceList ? "dc_pricelist" : "account-pricelist",
    };
  };


  // Fetch MRP and tax when Warehouse, ProductCode, or From_Date changes
  useEffect(() => {
    if (
      modalFormData.warehouse &&
      modalFormData?.ProductCode &&
      modalFormData.schemeStartDate &&
      priceListUpdateButton !== "Update DC Price"
    ) {
      console.log("Triggering API call...");
      updateMrpTax();
    }
  }, [
    modalFormData.warehouse,
    modalFormData?.ProductCode,
    modalFormData.schemeStartDate,
    priceListUpdateButton,
  ]);

  const updateMrpTax = () => {
    setLoadingMrpTax(true);
    if (priceListUpdateButton === "Update Account Price") {
      const apiEndpoint = "/api/getaccountpricelistmrptax";

      api
        .post(apiEndpoint, {
          body: {
            Warehouse: modalFormData.warehouse,
            ProductCode: modalFormData?.ProductCode,
            From_Date: modalFormData.schemeStartDate,
            page: "pricelist",
            user: user,
            currencyType: currency,
          },
        })
        .then((response) => {
          console.log("MRP/Tax API Response:", response.data);

          if (Array.isArray(response.data) && response.data.length > 0) {
            const { MRP, Tax } = response.data[0]; // Extract the first object

            // Multiply Tax by 100
            const updatedTax = Tax * 100;

            setModalFormData((prevData) => ({
              ...prevData,
              MRP,
              Tax: updatedTax,
            }));

            setSnackbarMessage("MRP/Tax data updated successfully.");
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
          } else {
            console.warn("No MRP/Tax data found:", response.data);

            setMrp("");
            setTax("");

            setSnackbarMessage("No MRP/Tax data found for this selection.");
            setSnackbarSeverity("warning");
            setSnackbarOpen(true);
          }
        })
        .catch((error) => {
          console.error("Error updating MRP/Tax:", error);
          setSnackbarMessage("Could not update MRP/Tax. Please try again.");
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        })
        .finally(() => {
          setLoadingMrpTax(false);
        });
    }
  };

  //submit Modal data handler
  const handleSubmit = () => {
    if (validateForm()) {
      const isDcPriceList = priceListUpdateButton === "Update DC Price";
      const apiEndpoint = isDcPriceList
        ? "/api/dcpricelist/add"
        : "api/accpricelist/add";

      const formatedData = {
        ...fomatBodyData(modalFormData, isDcPriceList),
        ...(isEditing && {
          ProductCode: selectedProductCode,
          id: getDcMrpTax[0]?.id,
        }),
        ...(!isDcPriceList && {
          MRP: modalFormData.MRP,
          Tax: modalFormData.Tax,
        }), // Use fetched MRP & Tax for Account Price List
      };

      setLoading(true);

      api
        .post(apiEndpoint, {
          body: formatedData,
        })

        .then((response) => {
          if (
            response.data?.Status === false ||
            response.data?.Message?.includes(
              "already available in the System You Can't Add"
            )
          ) {
            setSnackbarMessage(
              `This ${
                isDcPriceList ? "DC Pricelist" : "Account Pricelist"
              } is already added.`
            );
            setSnackbarSeverity("warning");
            setSnackbarOpen(true);
            setLoading(false);
          } else {
            // Success case
            updateRowData(response.data.data_updated);
            console.log(
              response.data.data_updated,
              "response.data.data_updated"
            );
            ResetForms();
            handleClose();
            setSnackbarMessage(
              `${
                isDcPriceList ? "DC Pricelist" : "Account Pricelist"
              } successfully added.`
            );
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error saving product:", error);
          setSnackbarMessage(
            `${
              isDcPriceList ? "DC PriceList" : "Account PriceList"
            } could not be added. Please try again later or contact support if the issue persists.`
          );

          setSnackbarSeverity("error");
          setSnackbarOpen(true);
          setLoading(false);
        });
    } else {
      console.log("!validateForm");
    }
  };

  // PTR Calculation
  const calculatePTR = (MRP, RetailMargin) => {
    if (!MRP || !RetailMargin) return "";
    const numericMRP = parseFloat(MRP);
    const numericMargin = parseFloat(RetailMargin);
    if (isNaN(numericMRP) || isNaN(numericMargin)) return "";
    return (numericMRP - numericMRP * (numericMargin / 100)).toFixed(2);
  };

  // Net PTR Calculation
  const calculateNetPTR = (PTR, Tax) => {
    if (!PTR || !Tax) return "";
    const numericPTR = parseFloat(PTR);
    const numericTax = parseFloat(Tax);
    if (isNaN(numericPTR) || isNaN(numericTax)) return "";
    return (numericPTR / (1 + numericTax / 100)).toFixed(2);
  };

  const handlePTRUpdate = (name, value) => {
    setModalFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      // Recalculate PTR if MRP or RetailMargin changes
      if (name === "MRP" || name === "RetailMargin") {
        updatedData.PTR = calculatePTR(
          updatedData.MRP,
          updatedData.RetailMargin
        );
      }

      // Recalculate Net PTR based on the latest PTR and Tax
      updatedData.NetPtr = calculateNetPTR(updatedData.PTR, updatedData.Tax);

      return updatedData;
    });
  };

  // model close functions
  const handleCloseWithReset = () => {
    handleClose();
    ResetForms();
  };

  // date picker style

  const customTheme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-input": {
              fontSize: "14px", // Font size for the input field
            },
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            fontSize: "12px", // Font size for the calendar days
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontSize: "12px", // Font size for typography inside the Date Picker
          },
        },
      },
    },
  });

  // modak content
  const modalContent = (
    <>
      <div>
        <Box
          sx={{
            bgcolor: "background.paper",
            maxWidth: 800,
            maxHeight: "80vh",
            overflowY: "auto",
            mx: "auto",
          }}
        >
          <Grid container spacing={2}>
            {/* warehouse */}
            <Grid item xs={12} sx={{ marginTop: "5px", width: "100%" }}>
              <FormControl
                style={{ width: "100%", flexGrow: 1 }}
                error={!!errors.warehouse}
              >
                <Autocomplete
                  disabled={isEditing}
                  options={warehouses.map(({ Warehouse }) => Warehouse)}
                  value={selectedWarehouse || ""}
                  onChange={handleWarehouseChange02 || handleWarehouseChange03}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Warehouse"
                      variant="outlined"
                      fullWidth
                      error={!!errors.warehouse}
                    />
                  )}
                  sx={{ width: "100%" }}
                  error={Boolean(errors.warehouse)}
                  size="small"
                />
                {errors.warehouse && (
                  <FormHelperText
                    sx={{
                      color: "#FF0000 !important",
                      marginTop: "4px !important",
                      marginLeft: "0",
                      marginRight: "0",
                    }}
                  >
                    {errors.warehouse}*
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            {/* product and price-list */}
            <Grid item sx={{ display: "flex", gap: "20px", width: "100%" }}>
              <FormControl fullWidth error={!!errors.product}>
                              <Autocomplete
                                options={productNames}
                                getOptionLabel={(option) =>
                                  option ? `${option.Product_Name} (${option.ProductCode})` : ""
                                }
                                isOptionEqualToValue={(option, value) =>
                                  option.ProductCode === value.ProductCode
                                }
                                value={productNames.find(
                                  (p) => p.ProductCode === modalFormData.ProductCode
                                ) || null}
                                onChange={handleProductChange}
                                disabled={isEditing}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Product"
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    error={!!errors.product}
                                  />
                                )}
                                sx={{ width: "100%" }}
                              />
                              {errors.product && (
                                <FormHelperText
                                  sx={{
                                    color: "#FF0000 !important",
                                    marginTop: "4px !important",
                                    marginLeft: "0",
                                    marginRight: "0",
                                  }}
                                >
                                  {errors.product}*
                                </FormHelperText>
                              )}
                            </FormControl>

              {priceListUpdateButton !== "Update DC Price" && (
                <>
                  {isEditing ? (
                    <TextField
                      value={selectedPriceList}
                      disabled={isEditing}
                      onChange={(e) => setSelectedPriceList(e.target.value)}
                      label="PriceList"
                      variant="outlined"
                      fullWidth
                      error={!!errors?.priceList}
                      helperText={errors?.priceList && "PriceList is required"}
                      onBlur={() => {
                        setIsEditing(false);
                        handlePriceListChangeInternal(null, {
                          Pricelist: selectedPriceList,
                        });
                      }}
                      size="small"
                    />
                  ) : (
                    <FormControl
                      style={{ width: "100%", flexGrow: 1 }}
                      error={!!errors.priceList}
                    >
                      <Autocomplete
                        options={priceLists}
                        disabled={isEditing}
                        getOptionLabel={(option) => option.Pricelist || ""}
                        value={selectedPriceList}
                        onChange={
                          handlePriceListChange || handlePriceListChange02
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="PriceList"
                            variant="outlined"
                            fullWidth
                            error={!!errors.priceList}
                          />
                        )}
                        sx={{ width: "100%" }}
                        size="small"
                      />
                      {errors.priceList && (
                        <FormHelperText
                          sx={{
                            color: "#FF0000 !important",
                            marginTop: "4px !important",
                            marginLeft: "0",
                            marginRight: "0",
                          }}
                        >
                          {errors.priceList}*
                        </FormHelperText>
                      )}
                    </FormControl>
                  )}
                </>
              )}
            </Grid>
            {/* date */}
            <ThemeProvider theme={customTheme}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box
                  className="pricelist-date-picker"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "20px",
                    marginTop: "20px",
                    marginLeft: "16px",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <DatePicker
                      label="From Date"
                      sx={{ width: "100%" }}
                      value={
                        modalFormData.schemeStartDate
                          ? dayjs(modalFormData.schemeStartDate)
                          : null
                      }
                      onChange={(newValue) => {
                        const newStartDate = newValue
                          ? newValue.format("YYYY-MM-DD")
                          : "";
                        const newEndDate = newValue
                          ? newValue.add(15, "year").format("YYYY-MM-DD")
                          : "";

                        setModalFormData((prevData) => ({
                          ...prevData,
                          schemeStartDate: newStartDate,
                          schemeEndDate: newEndDate,
                        }));
                        if (newValue) {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            schemeStartDate: "",
                            schemeEndDate: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          margin="normal"
                          error={Boolean(errors.schemeStartDate)}
                          helperText={errors.schemeStartDate}
                          sx={{
                            "& .MuiInputBase-root": {
                              borderColor: errors.schemeStartDate
                                ? "red"
                                : undefined,
                            },
                          }}
                        />
                      )}
                      disablePast={true}
                      shouldDisableDate={
                        shouldDisableDate ? disableDateCondition : undefined
                      }
                      slotProps={{
                        field: {
                          clearable: true,
                          onClear: () => setCleared(true),
                        },
                      }}
                    />
                    {errors.schemeStartDate && (
                      <FormHelperText
                        sx={{
                          color: "#FF0000",
                          marginTop: "4px",
                        }}
                      >
                        {errors.schemeStartDate}*
                      </FormHelperText>
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <DatePicker
                      label="To Date"
                      sx={{ width: "100%" }}
                      value={
                        modalFormData.schemeEndDate
                          ? dayjs(modalFormData.schemeEndDate)
                          : null
                      }
                      onChange={(newValue) => {
                        setModalFormData((prevData) => ({
                          ...prevData,
                          schemeEndDate: newValue
                            ? newValue.format("YYYY-MM-DD")
                            : "",
                        }));
                        if (newValue) {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            schemeEndDate: "",
                          }));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth margin="normal" />
                      )}
                      disablePast={true}
                      disabled={true}
                      shouldDisableDate={
                        shouldDisableDate ? disableDateCondition : undefined
                      }
                      slotProps={{
                        field: {
                          clearable: true,
                          onClear: () => setCleared(true),
                        },
                      }}
                    />
                    {errors.schemeEndDate && (
                      <FormHelperText
                        sx={{
                          color: "#FF0000",
                          marginTop: "4px",
                        }}
                      >
                        {errors.schemeEndDate}*
                      </FormHelperText>
                    )}
                  </Box>
                </Box>
              </LocalizationProvider>
            </ThemeProvider>
            {/* MRP & Retail margin */}
            <Grid item xs={12} sx={{ display: "flex", gap: "20px" }}>
              <Grid item xs={6} sx={{ width: "100%" }}>
                <TextField
                  fullWidth
                  sx={{ width: "100%" }}
                  label="MRP"
                  name="MRP"
                  value={modalFormData.MRP}
                  onChange={(e) => {
                    const value = e.target.value;
                    setModalFormData((prevData) => ({
                      ...prevData,
                      MRP: value,
                    }));
                    if (value) {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        MRP: "",
                      }));
                    }
                    // Call PTR update logic
                    handlePTRUpdate("MRP", value);
                  }}
                  error={Boolean(errors.MRP)}
                  size="small"
                  disabled={priceListUpdateButton === "Update Account Price"}
                />
                {errors.MRP && (
                  <FormHelperText
                    sx={{
                      color: "#FF0000",
                      marginTop: "4px",
                    }}
                  >
                    {errors.MRP}*
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={6} sx={{ width: "100%" }}>
                <TextField
                  fullWidth
                  sx={{ width: "100%" }}
                  label="Retailer Margin %"
                  name="Retailer Margin %"
                  value={modalFormData.RetailMargin}
                  onChange={(e) => {
                    const value = e.target.value;
                    setModalFormData((prevData) => ({
                      ...prevData,
                      RetailMargin: value,
                    }));
                    if (value) {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        RetailMargin: "",
                      }));
                    }
                    // Call PTR update logic
                    handlePTRUpdate("RetailMargin", value);
                  }}
                  error={Boolean(errors.RetailMargin)}
                  size="small"
                />
                {errors.RetailMargin && (
                  <FormHelperText
                    sx={{
                      color: "#FF0000",
                      marginTop: "4px",
                    }}
                  >
                    {errors.RetailMargin}*
                  </FormHelperText>
                )}
              </Grid>
            </Grid>
            {/* PTR & Tax */}
            <Grid item xs={12} sx={{ display: "flex", gap: "20px" }}>
              <Grid item xs={6} sx={{ width: "100%" }}>
                <TextField
                  disabled
                  fullWidth
                  sx={{ width: "100%" }}
                  label="PTR"
                  name="PTR"
                  value={modalFormData.PTR}
                  onChange={(e) => {
                    const value = e.target.value;
                    setModalFormData((prevData) => ({
                      ...prevData,
                      PTR: value,
                    }));
                    if (value) {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        PTR: "",
                      }));
                    }
                  }}
                  error={Boolean(errors.PTR)}
                  size="small"
                />
                {errors.PTR && (
                  <FormHelperText
                    sx={{
                      color: "#FF0000",
                      marginTop: "4px",
                    }}
                  >
                    {errors.PTR}*
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={6} sx={{ width: "100%" }}>
                <TextField
                  fullWidth
                  label="Tax %"
                  name="Tax %"
                  sx={{ width: "100%" }}
                  value={modalFormData.Tax}
                  onChange={(e) => {
                    const value = e.target.value;
                    setModalFormData((prevData) => ({
                      ...prevData,
                      Tax: value,
                    }));
                    if (value) {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        Tax: "",
                      }));
                    }
                    handlePTRUpdate("Tax", value);
                  }}
                  error={Boolean(errors.Tax)}
                  size="small"
                  disabled={priceListUpdateButton === "Update Account Price"}
                  InputLabelProps={{ shrink: true }}
                />
                {errors.Tax && (
                  <FormHelperText
                    sx={{
                      color: "#FF0000",
                      marginTop: "4px",
                    }}
                  >
                    {errors.Tax}*
                  </FormHelperText>
                )}
              </Grid>
            </Grid>
            {/* PTR Net */}
            <Grid
              item
              xs={6}
              sx={{ display: "flex", gap: "20px", width: "100%" }}
            >
              <Grid
                //  item
                sx={{ width: "100%" }}
              >
                <TextField
                  disabled
                  fullWidth
                  sx={{ width: "100%" }}
                  label="Net PTR"
                  name="Net PTR"
                  value={modalFormData.NetPtr}
                  onChange={(e) => {
                    const value = e.target.value;
                    setModalFormData((prevData) => ({
                      ...prevData,
                      NetPtr: value,
                    }));
                    if (value) {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        NetPtr: "",
                      }));
                    }
                  }}
                  error={Boolean(errors.NetPtr)}
                  size="small"
                />
                {errors.NetPtr && (
                  <FormHelperText
                    sx={{
                      color: "#FF0000",
                      marginTop: "4px",
                    }}
                  >
                    {errors.NetPtr}*
                  </FormHelperText>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );

  // modal buttons
  const actionButtons = (
    <>
      <LoadingButton
        variant="contained"
        color="primary"
        loading={isLoading}
        loadingPosition="end"
        onClick={() => {
          handleSubmit();
        }}
        style={{
          fontSize: "12px",
          backgroundColor: "#17A591",
          color: "white",
          marginRight: "8px",
          backgroundColor: isLoading ? "#16a69590" : "#16a695",
          paddingRight: isLoading ? "35px" : "",
        }}
        size="small"
      >
        {priceListUpdateButton}
      </LoadingButton>

      <Button
        variant="outlined"
        onClick={() => {
          handleClose();
          ResetForms();
        }}
        style={{ fontSize: "12px", color: "#000", borderColor: "#707070" }}
        size="small"
      >
        Cancel
      </Button>
    </>
  );

  return (
    <>
      <ModalComp
        open={open}
        setCustomOpenModal={setCustomOpenModal}
        handleClose={handleCloseWithReset}
        title={
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {priceListUpdateButton === "Update DC Price"
              ? "Add New DC Price"
              : "Add New Account Price"}
            {loadingMrpTax && (
              <LoadingSpinner
                color="#17A591"
                width={"25px !important"}
                height={"25px !important"}
              />
            )}
          </span>
        }
        modalContent={modalContent}
        modelButtons={actionButtons}
        // onSave={handleSave}
        datePickerStyle={{ width: "48%", margin: "5px" }}
        themeStyles={{
          boxStyle: {
            width: "682px",
            height: "auto",
            margin: "auto",
            marginTop: "80px",
          },
          titleStyle: {
            fontSize: "18px",
            fontWeight: 600,
            color: "#000",
            backgroundColor: "#F4F4F4",
            padding: "24px",
            position: "sticky",
            top: 0,
            zIndex: 10,
          },
          actionButtonContainerStyle: {
            padding: "0 20px 20px 20px",
          },
          fieldStyle: { width: "100%", marginTop: "20px" },
        }}
      />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default AddNewPricelist;
